import { combineReducers } from 'redux'
import catalog from './catalog'
import setup from './setup'
import warehouseSetup from './warehouse-setup'
import lockouts from './lockouts'
import workspaceActivity from './workspace-activity'
import workspaceSettings from './workspace-settings'
import sourcesList from './sources-list'
import sourceSetup from './source-setup'
import app from './app'
import sourceIntegrations from './source-integrations'
import sourceSchema from './source-schema'
import sourceSettings from './source-settings'
import workspaceDestinations from './workspace-destinations'
import workspaceSources from './workspace-sources'
import workspaceOverview from './workspace-overview'
import partners from './partners'
import sourceDebugger from './source-debugger'

export default combineReducers({
  catalog,
  setup,
  warehouseSetup,
  workspaceActivity,
  lockouts,
  workspaceSettings,
  sourcesList,
  sourceSettings,
  sourceSetup,
  app,
  sourceIntegrations,
  sourceSchema,
  workspaceDestinations,
  workspaceSources,
  workspaceOverview,
  partners,
  sourceDebugger
})
